import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Box, Button, Collapse, IconButton, Paper, Stack, Switch, TableCell, TableRow, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { Seismic3DData } from 'features/seismic-3d/models/classes/Seismic3DData';
import { use3DGridStore } from 'features/seismic-3d/stores/use3DGridStore';
import { ISurveyMetadata } from 'features/seismic/models/interfaces/ISurveyMetadata';

type Props = {
    seismicData: ISurveyMetadata,
    selected: boolean,
    onToggle: (checked: boolean) => void,
};

export const SelectedSeismicsListRow = ({ seismicData, selected, onToggle } : Props) => {
    const [collapsed, setCollapsed] = useState<boolean>(false);

    const displayLabel = useMemo(() => seismicData.ProductName ?? seismicData.DisplayName, [seismicData]);

    return (
        <Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell size='small'>
                    <IconButton
                        aria-label='expand-row'
                        size='small'
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        { collapsed ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> }
                    </IconButton>
                </TableCell>
                <TableCell>
                    {displayLabel.length > 30 ? displayLabel.substring(0, 30) + '...' : displayLabel}
                </TableCell>
                <TableCell>
                    <Switch checked={selected} onChange={(evt, checked) => onToggle(checked)}/>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={3}>
                    <Collapse in={collapsed} timeout='auto' unmountOnExit >
                        <Box>
                            <Stack spacing={0.5}>
                                <Typography variant='body2'><strong>Number of traces:</strong> {' ' + seismicData.Header.NumberOfTraces}</Typography>
                                <Typography variant='body2'><strong>Samples per trace:</strong> {' ' + seismicData.Header.SamplesPerTrace}</Typography>
                                <Typography variant='body2'><strong>Samples interval:</strong> {' ' + seismicData.Header.SampleInterval}</Typography>
                            </Stack>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
};